
<div class="card mb-0">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4>{{ data.title | capitalCase }}</h4>
    </div>
  </div>

  <div class="card-body" style="padding: 0px;">
    <!-- ✅ Custom Legend -->
    <div class="legend-wrapper" *ngIf="chartData.length > 0">

      <button
        class="scroll-arrow"
        *ngIf="showLeftArrow"
        (click)="scrollLegend('left')">
        ‹
      </button>

      <div
        #legendContainer
        class="custom-legend-container"
        (scroll)="updateArrowVisibility()">

        <div
          class="legend-item"
          *ngFor="let item of chartData"
          (click)="onLegendItemClick(item)"
          [style.cursor]="data?.enableLegendClick ? 'pointer' : 'default'"
          [style.opacity]="currentlySelectedIndices.length === 0 ? 1 : (allSliceNames.indexOf(item.label) !== -1 && currentlySelectedIndices.includes(allSliceNames.indexOf(item.label)) ? 1 : 0.3)">

          <span
            class="legend-color-box"
            [style.background]="item.color">
          </span>

          <span class="legend-label">
            {{ item.label }}
          </span>

        </div>
      </div>

      <button
        class="scroll-arrow"
        *ngIf="showRightArrow"
        (click)="scrollLegend('right')">
        ›
      </button>

    </div>

    <div
      class="donut-chart-shell"
      [class.with-legend]="chartData.length > 0"
      [style.--donut-target-height]="getChartHeight()"
    >
      <div
        [id]="data.widgetId"
        class="donut-chart-canvas"
      ></div>
    </div>
  </div>
</div>
